import { ReactComponent as AddIcon } from '../../components/icons/add-icon.svg';
import { ReactComponent as Trash } from '../../components/icons/trash.svg';
import { ReactComponent as TwoPeople } from '../../components/icons/two-people.svg';
import { ReactComponent as UserOctagon } from '../../components/icons/user-octagon.svg';
import { ReactComponent as SearchIcon } from '../../components/icons/search.svg';
import SortArrows from '../../components/icons/sort-arrows.jsx';
import CustomButton from '../../components/components/custom_button/customButton';
import CustomInput from '../../components/components/custom_input/customInput';
import {setKeyword, setSearchValue} from "../../store/userTabSlice";

// Akcje dla tabeli użytkowników
export const userActions = {
  deleteSelected: (selectedIds) => {
    console.log('Usuń zaznaczone użytkowników:', selectedIds);
    alert('W trakcie implementacji!')
    // Logika usuwania użytkowników na podstawie zaznaczonych ID
  },
  changeTab: (tabName, dispatch, setActiveUsersTab) => {
    console.log('Zmieniono zakładkę na:', tabName);
    dispatch(setActiveUsersTab(tabName));
  },
};

// Konfiguracja nagłówków tabeli
export const getHeaders = (sortBy, sortDirection, dispatch, setSorting, sortArrowColorActive, sortArrowColorInactive, rowsUsers, checkedItems) => [
  'ID',
  <div className="table-columns-headers">
    <div>Data dodania</div>
  </div>,
  <div className="table-columns-headers">
    <div>Osoba wystawiająca</div>
  </div>,
  <div className="table-columns-headers">
    <div>Opinia</div>
  </div>
];

// Szerokości kolumn
export const headerWidthsForUserOpinions = ['34px', '1fr', '2fr', '1fr'];

// Konfiguracja zakładek
export const tabsConfig = (activeUsersTab, dispatch, setActiveUsersTab) => [
  {
    icon: TwoPeople,
    name: 'Użytkownicy',
    hoverClass: 'hover-effect',
    activeClass: activeUsersTab === 'Użytkownicy' ? 'is-active' : '',
    onClick: () => userActions.changeTab('Użytkownicy', dispatch, setActiveUsersTab),
    toggleActive: true,
  },
  {
    icon: UserOctagon,
    name: 'Administratorzy',
    hoverClass: 'hover-effect',
    activeClass: activeUsersTab === 'Administratorzy' ? 'is-active' : '',
    onClick: () => userActions.changeTab('Administratorzy', dispatch, setActiveUsersTab),
    toggleActive: true,
  },
];

// Konfiguracja przycisków
export const buttonsConfig = (toggleAddModal) =>[
  {
    icon: AddIcon,
    name: 'Dodaj użytkownika',
    baseClass: 'custom-button-black',
    hoverClass: 'hover-effect',
    activeClass: '',
    onClick: () => {
      toggleAddModal();
    },
    toggleActive: false,
  },
];

export const empty = [];

// Konfiguracja lewej strony
export const leftSideConfig = [
    {
        component: CustomButton,
        props: {
          icon: Trash,
          name: 'Usuń konto',
          baseClass: 'custom-button-white',
          hoverClass: 'hover-effect',
          activeClass: '',
          borders: 'LRBT',
          onClick: () => userActions.deleteSelected([]), // Przekaż tutaj zaznaczone ID użytkowników
          toggleActive: false,
        },
    },
    {
        component: CustomButton,
        props: {
            icon: Trash,
            name: 'Zablokuj konto',
            baseClass: 'custom-button-white',
            hoverClass: 'hover-effect',
            activeClass: '',
            borders: 'LRBT',
            onClick: () => userActions.deleteSelected([]), // Przekaż tutaj zaznaczone ID użytkowników
            toggleActive: false,
        },
    },
    {
        component: CustomButton,
        props: {
            icon: Trash,
            name: 'Odblokuj konto',
            baseClass: 'custom-button-white',
            hoverClass: 'hover-effect',
            activeClass: '',
            borders: 'LRBT',
            onClick: () => userActions.deleteSelected([]), // Przekaż tutaj zaznaczone ID użytkowników
            toggleActive: false,
        },
    },
];

// Konfiguracja prawej strony
export const rightSideConfig = (searchValue, dispatch) => [
  {
    component: CustomInput,
    props: {
      icon: SearchIcon,
      placeholder: 'Wyszukaj',
      hoverClass: 'hover-effect',
      borders: 'LRBT',
      bordersClassPrefix: 'border-black-',
      baseClass: 'custom-input',
      activeClass: '',
      value: searchValue,
      onChange: (e) => {
        e.preventDefault();
        let value = e.target.value;
        dispatch(setSearchValue(value)); // Ustaw wartość wyszukiwania w stanie lokalnym
        if (value.length >= 3 ) {
          dispatch(setKeyword(value)); // Aktualizuj stan w Reduxie
        } else {
          dispatch(setKeyword(null)); // Resetuj stan w Reduxie, jeśli mniej niż 3 znaki
        }
      }
      }
  },
];